<template>
  <div class="contact">
    <div class="w-[1280px] mx-auto">
      <Banner :background="contactBg" />
      <div class="mt-[24px] pt-[30px] pb-[48px] bg-back-1 py-[44px] px-[72px] rounded-[12px]">
        <template v-if="!submitSuccess">
          <a-alert
            :message="
              $t(
                'huan-ying-ge-wei-you-yan-tou-hao-wan-jia-qing-xian-an-huo-dong-yao-qiu-tian-xie-nin-de-xin-xi-shen-qing-ti-jiao-wan-cheng-hou-nin-jiang-mian-fei-huo-qu-600-yan-bi-de-shi-yong-quan-yi-shen-qing-cheng-gong-hou-nin-jiang-hui-shou-dao-duan-xin-ji-xiao-xi-zhong-xin-de-tong-zhi-mei-ge-yong-hu-jin-xian-shen-qing-yi-ci-mingeyou-xian-qing-zhua-jin-shi-jian-bao-ming-ti-yan-ba',
              )
            "
            type="info"
            show-icon
          />
          <Form class="mt-[24px]" @submit-success="onSubmitSuccess" />
        </template>
        <template v-else>
          <div class="flex flex-col items-center justify-center">
            <iconpark-icon name="circle-success" size="56"></iconpark-icon>
            <div class="mt-[16px] font-medium text-[20px] text-font-1">
              {{ submitResult.title }}
            </div>
            <div class="mt-[16px] text-font-60 leading-[22px] text-center">
              <div v-for="des in submitResult.description" :key="des">
                {{ des }}
              </div>
            </div>
            <a-button type="primary" class="mt-[20px]" @click="gotoPrime">
              {{ $t('hui-dao-shou-ye') }}
            </a-button>
            <div class="h-[128px] text-center mt-[30px]">
              <Resource
                class="h-full"
                :src="contactQr"
                :alt="$t('you-yan-huo-dong-qun-er-wei-ma')"
              />
            </div>
            <div class="mt-[12px] text-font-1 opacity-30 text-center leading-[20px] text-[12px]">
              <div>{{ $t('jia-ru-you-yan-huo-dong-qun') }}</div>
              <div>{{ $t('huo-qu-zui-xin-huo-dong-xin-xi') }}</div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import Banner from './components/banner/index.vue';
import Form from './components/form/index.vue';
import { useTime } from '~/hooks/useTime';
import type { YanbiApplyResponse } from '~/api/interface';
import { useTaste } from '~/hooks/useTaste';

const { $t } = useNuxtApp();
const { timezoneFormat } = useTime();

const submitSuccess = ref(false);
const contactBg = transformImage(getFeUrl('/youyan-platform/png/applyYanbiBanner.png'), {
  height: 520,
});
const contactQr = transformImage(getFeUrl('/youyan-platform/jpeg/apply_qr.jpeg'));

const submitResult = ref<{ title: string; description: string[] }>({
  title: '',
  description: [],
});

function onSubmitSuccess(data: YanbiApplyResponse) {
  submitSuccess.value = true;

  if (data.index === 0) {
    submitResult.value.title = $t('ti-jiao-cheng-gong-quan-yi-yi-sheng-xiao');
    submitResult.value.description = [
      $t('shen-qing-cheng-gong-li-ji-kai-shi-ni-de-3d-shi-pin-chuang-zuo-ba'),
      $t(
        'qing-zai-shi-yong-you-xiao-qi-nei-wan-cheng-ti-yan-shi-yong-dao-qi-shi-jian-timezoneformat-dataexpiredtimestamp-yyyy-nian-mm-yue-dd-ri',
        [timezoneFormat(data.expired_timestamp!, $t('yyyy-nian-mm-yue-dd-ri'))],
      ),
    ];
  } else {
    // 排队中
    submitResult.value.title = $t('ti-jiao-cheng-gong-quan-yi-dai-sheng-xiao');
    submitResult.value.description = [
      $t('dang-qian-shi-yongedu-yi-man-yi-wei-nin-pai-dui-deng-hou-wei-yu-dataindex-wei', [
        data.index,
      ]),
      $t('cheng-gong-hou-quan-yi-jiang-zi-dong-fa-fang-bing-tong-zhi-nin'),
    ];
  }
}

function gotoPrime() {
  navigateTo('/');
}

async function onCheckApply() {
  await useTaste();
}

onMounted(onCheckApply);
</script>
<style lang="scss" scoped>
.contact {
  @apply pt-[30px] overflow-scroll;
  height: calc(100vh - 30px);
}
</style>
